import React, { useMemo } from 'react'
import { HelpDrawerWithAccordion } from '@labrav/common'
import {
  FaqQuestion,
  HelpDrawerFaqItems,
} from '../../FlyoutProductFormHelpFaqs/ProductCreationFaqUtil'

export enum MicrosoftHelpAndFAQsItem {
  MIGRATE_PRODUCT = 'migrate-product',
}

interface MicrosoftHelpAndFAQsProps {
  item?: MicrosoftHelpAndFAQsItem
  isImpartner?: boolean
}

export const MicrosoftHelpAndFAQs: React.FC<MicrosoftHelpAndFAQsProps> = ({
  item,
  isImpartner,
}) => {
  const migrateProduct: HelpDrawerFaqItems[] = [
    {
      question: (
        <FaqQuestion
          section={''}
          question="Is there any limit on how many products I can migrate?"
        />
      ),
      answer: <div>No, you can migrate any number of listing you want to.</div>,
    },
    ...(!isImpartner
      ? [
          {
            question: (
              <FaqQuestion
                section={''}
                question="How soon will my products be migrated here?"
              />
            ),
            answer: (
              <div>
                Once the Buyer registration page and Notification section is
                completed and has been submitted by you, the listing migration
                process will be initiated and will take a couple of hours to be
                completed.
              </div>
            ),
          },
        ]
      : []),
    {
      question: (
        <FaqQuestion
          section={''}
          question="Will I be able to manage the migrated listings?"
        />
      ),
      answer: (
        <div>
          Yes, you can manage all your migrated listing via this platform.
        </div>
      ),
    },
  ]

  const faqItems = useMemo(() => {
    switch (item) {
      case MicrosoftHelpAndFAQsItem.MIGRATE_PRODUCT:
        return migrateProduct
      default:
        return []
    }
  }, [item])

  return (
    <HelpDrawerWithAccordion
      headerTitle="Help & FAQs"
      faqItems={faqItems}
      faqTitle="Select products to migrate to Labra"
      divider
    />
  )
}
